import fizapilib, { decoder, encoder, JsonFw } from "./fizapilib.ts";
import FizConfig from "../FizConfig.js";

const API = FizConfig.API_BASE_URL+"api";

type Call = [name:string,data: {[x:string]:string}, resolve :(value: any) => void, reject :(reason?: any) => void]

function a0i(i :number){
  if(i<0) throw new Error("Invalid call a"+i)
  if(i===0) return '';
  if(i<10) return 'a0'+i
  if(i<100) return 'a'+i
  throw new Error("Invalid call a"+i)
}


const multiplexer = {
  calls:[] as Call[],
  timeout:undefined,
  add(call :Call){
    this.calls.push(call)
    
    clearTimeout(this.timeout)
    this.timeout = setTimeout(()=>this.execute(),50)
  },
  async execute(){
    var 
      post = new FormData(),
      calls = this.calls;
    this.calls = [];  
    calls.forEach(([name,data,resolve,reject],index)=>{
      const a0x = a0i(index);
      if(index!==0){
        post.append(a0x+"call", name)
      }
      Object.entries(data).forEach(([key,value],index)=>{
        post.append(a0x+key, value)
      })
    })
    return fetch(API+'/'+calls[0][0], {
      method: 'POST',
      body: post,
      credentials: 'include'
        
    })
    .then((response) => response.json())
    .then((json)=>{
      var errors = []
      Object.entries(json).forEach(([key,value],index)=>{
        var [name,data,resolve,reject] = calls[index];
        try{
          resolve(value)
        }catch(e){
          try{
            reject(e)
          }catch(errorAfterHandling){
            errors.push(errorAfterHandling)
          }
        }
      })
      if(errors.length===1) throw errors[0]
      if(errors.length>1){
        throw Object.assign(new Error(errors.map(e=>e.message).join()),{stack:errors.map(e=>e.stack).join('\n')});
      }
    })
  }
}

function flattenobject(prefix :string,src :JsonFw[]|JsonFw|string,target : {[x:string]:string}){
  if(Array.isArray(src)){
    src.forEach((sub,key)=>{
      flattenobject(prefix===undefined?key.toString():prefix+"."+key,sub,target)
    })
  }else if(typeof src === 'object'){
    Object.entries(src).forEach(([key,sub],index)=>{
      flattenobject(prefix===undefined?key:prefix+"."+key,sub,target)
    })
  }else{
    target[prefix] = src;
  }
}

fizapilib.setExecutorTs(async function(method :string, model :{[x:string]:encoder<Object>},decoder:decoder<Object>,args :any[]){
  var jsonRequest : {[x:string]:string} = {}
  Object.entries(model).forEach(([key,encoder],index)=>{
    var 
      encoded = encoder(args[index]);
    flattenobject(key==='__inline'?undefined:key,encoded,jsonRequest)
  })
  return new Promise((resolve,reject)=>{
    multiplexer.add([method,jsonRequest,(response)=>resolve(decoder(response)),reject])
  })
})
export default fizapilib.methodsTs;
